import React from 'react';
import {StyledCell} from "./index";

const TreeCell  = () => {
    return (
        <StyledCell>
            <img src='/christmasTree.png' alt='tree' />
        </StyledCell>
    );
}

export default TreeCell;
